import type { ClientStatus, PaymentTerms } from '@/modules/clients/types/client';
import type { OpsiumUserShort } from '@/modules/common/types/opsium-user';

import type {
  InvoiceClientInfo,
  InvoiceProjectInfo,
  InvoiceStatus,
  InvoiceSyncError,
  InvoiceSyncOperation,
} from './invoice';

export enum InvoiceSyncStatus {
  Scheduled = 'SCHEDULED',
  InProgress = 'IN_PROGRESS',
  Synchronized = 'SYNCHRONIZED',
  Failed = 'FAILED',
}

export enum InvoiceAllowedAction {
  Edit = 'EDIT',
  Delete = 'DELETE',
  Retry = 'RETRY',
}

export enum InvoiceEntityType {
  User = 'USER',
  Unknown = 'UNKNOWN',
  Overhead = 'OVERHEAD',
}

export interface InvoiceDetailsClient extends InvoiceClientInfo {
  isDeleted: boolean;
  status: ClientStatus;
}

export interface InvoiceDetailsItem {
  entityType: InvoiceEntityType;
  entityId: number | null;
  description: string | null;
  quantity: string | null;
  unitPrice: string | null;
  amount: string;
  member: OpsiumUserShort | null;
}

export interface InvoiceDetails {
  id: number;
  externalId: string | null;
  referenceNumber: string | null;
  status: InvoiceStatus;
  syncStatus: InvoiceSyncStatus;
  syncOperation: InvoiceSyncOperation | null;
  syncError: InvoiceSyncError | null;
  syncToken: string;
  allowedActions: InvoiceAllowedAction[];
  project: InvoiceProjectInfo | null;
  client: InvoiceDetailsClient;
  startDate: string | null;
  endDate: string | null;
  issuedDate: string;
  dueDate: string;
  paymentTerm: PaymentTerms | null;
  currencyCode: string;
  totalAmount: string;
  balance: string;
  amountPaid: string;
  paymentDetailsId: number | null;
  paymentMemo: string | null;
  items: InvoiceDetailsItem[];
}
